import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { emily } from "../characters/Emily";
import { mc } from "../characters/MC";
import { doTransition } from "../helpers/helpers";
import { images } from "./images";
import { V5AfterBeachJoeyOrEmily } from "./V5";

export const V5EmilyBeach = async (): Promise<any> => {
    doTransition(images.v5.BeachEmily_1);
    emily.talk(`It's been so long!`);
    emily.talk(`I didn't have a close beach nearby where I was living. I've missed it!`);
    ImageClass.setImage(images.v5.BeachEmily_0);
    emily.talk(`There is a good spot for us to sit, let's go.`);
    mc.talk(`Right behind you.`);
    ImageClass.setImage(images.v5.BeachEmily_2, { transition: true });

    emily.talk(`I'm glad that you came.`);
    emily.talk(`I thought you are going to refuse to do those things you do on the computer.`);
    mc.talk(`Yeah... I'm trying to change.`);
    emily.talk(`I like it!`);
    ImageClass.setImage(images.v5.BeachEmily_3);
    emily.talk(`It's time to catch some sun! I've almost lost my tan!`);
    ImageClass.setImage(images.v5.BeachEmily_4);
    emily.talk(`Hey, isn't that Joey?`);
    ImageClass.setImage(images.v5.BeachEmily_5);
    emily.talk(`I didn't notice him.`);
    mc.talk(`That's him.`);
    emily.talk(`Why did he run off if he is sitting alone?`);
    return jump(V5EmilyBeach1, "V5EmilyBeach1");
};
export const V5EmilyBeach1 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.BeachEmily_5);
    emily.talk(`Did something happen between you two?`);
    mc.talk(`We had a small fight.`);
    emily.talk(`Really? What happened?`);
    mc.talk(`It's a long story.`);
    emily.talk(`Keeping secrets from me?`);
    mc.talk(`I'll tell you when it's the right time.`);
    emily.talk(`Promise?`);
    mc.talk(`Yes.`);
    emily.talk(`I'll remember that!`);
    mc.talk(`Haha, I'm sure.`);
    return jump(V5EmilyBeach2, "V5EmilyBeach2");
};

export const V5EmilyBeach2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.BeachEmily_6);
    emily.talk(`To a different subject!`);
    emily.talk(`What's new with you?`);
    mc.talk(`What do you want to know?`);
    emily.talk(`Everything!`);
    emily.talk(`Do you enjoy your freedom? What do you plan to do in life?`);
    emily.talk(`Or the most important question. Do you have a girl in your life???`);
    mc.talk(`I'll start with the easy questions.`);
    mc.talk(`I haven't thought about what I'm going to do with my life yet...`);
    emily.talk(`What are you waiting for?`);
    mc.talk(`I know I know, I'll start by looking for a job soon.`);
    emily.talk(`Honesty, I always believe you will become rich by doing the magic tricks you do while sitting on the computer.`);
    mc.talk(`Haha, don't be silly. I usually just play games and pass the time.`);
    emily.talk(`In any case, I believe in you.`);
    mc.talk(`Thank you Emily.`);
    emily.talk(`And what about the other question?`);

    return jump(V5EmilyBeach3, "V5EmilyBeach3");
};

export const V5EmilyBeach3 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.BeachEmily_7);
    mc.talk(`About that...`);
    if (mc.properties.annStatus === "gf") {

        return jump(V5EmilyBeachAnnConversationLove1, "V5EmilyBeachAnnConversationLove1");
    }
    return jump(V5EmilyBeachAnnConversationHate1, "V5EmilyBeachAnnConversationHate1");
};

export const V5EmilyBeachAnnConversationLove1 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.BeachEmily_7);
    mc.talk(`I am seeing someone.`);
    ImageClass.setImage(images.v5.BeachEmily_9);
    emily.talk(`Are you? What's her name?`);
    mc.talk(`Ann.`);
    ImageClass.setImage(images.v5.BeachEmily_10);
    emily.talk(`That's a beautiful name.`);
    emily.talk(`How did you meet her?`);
    mc.talk(`Vanessa introduced us.`);
    emily.talk(`Who is that?`);
    mc.talk(`Joey's girlfriend...`);
    emily.talk(`Joey also has a girlfriend? Look at you two!`);
    ImageClass.setImage(images.v5.BeachEmily_11);

    emily.talk(`I can't believe I've missed so much.`);
    emily.talk(`So tell me a bit about Ann! What's she like?`);

    mc.talk(`She is really cute and innocent.`);
    if (mc.properties.alpha >= 5 || ann.properties.corruption >= 5) {
        mc.talk(`But I plan to change it.`);
        emily.talk(`Change it? In what way?`);
        mc.talk(`I'll help her get over her shyness.`);
        emily.talk(`Did you ask her if that's something she would want?`);
        mc.talk(`She would want it, trust me.`);
        emily.talk(`You know I've always agreed with your decisions, and I don't know her so I have no reason to disagree.`);
    } else {

    }
    ImageClass.setImage(images.v5.BeachEmily_12);
    emily.talk(`I know I'm not supposed to ask, but I am really way too curious.`);
    emily.talk(`Did you have sex?`);
    mc.talk(`Not yet, but I'm working on it.`);
    emily.talk(`What's holding you back?`);
    mc.talk(`She is, but don't worry.`);

    emily.talk(`I can't believe I can finally talk to you about these kinds of things.`);
    emily.talk(`I waited for so long for you to bring a girl home.`);
    emily.talk(`Maybe you just needed me to move out to do that, haha.`);
    mc.talk(`Maybe, haha.`);

    return jump(V5EmilyBeachAnnConversation2, "V5EmilyBeachAnnConversation2");
};

export const V5EmilyBeachAnnConversation2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.BeachEmily_13);
    emily.talk(`Sooo... When am I going to meet her?`);
    mc.talk(`I'm sure you will meet her really soon, we spend a lot of time together.`);
    emily.talk(`I hope you are not an annoying, clingy couple.`);
    mc.talk(`Haha, no...`);

    return jump(V5EmilyBeach4, "V5EmilyBeach4");
};

export const V5EmilyBeachAnnConversationHate1 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.BeachEmily_13);
    mc.talk(`Joey's girlfriend, Vanessa, tried to match me up with a girl, but it didn't work out.`);
    emily.talk(`Joey has a girlfriend???`);
    mc.talk(`Yes.`);
    mc.think(`Well... After yesterday it's not certain...`);
    emily.talk(`I can't believe I missed so much.`);
    emily.talk(`So why didn't it work out?`);
    if (Question.globalAnswers.v3JoeGymWhyDislikeAnn === "notFreaky") {
        mc.talk(`She is not freaky enough.`);
        emily.talk(`So? Give her some time, people change.`);
        mc.talk(`I doubt she will... You don't know her.`);
        emily.talk(`I really don't so I can't really comment about that.`);
    } else if (Question.globalAnswers.v3JoeGymWhyDislikeAnn === "sheIsUgly") {
        mc.talk(`She is ugly.`);
        emily.talk(`Oh... Is it that bad?`);
        mc.talk(`Yeah...`);
        mc.talk(`Well, I don't have much to say about that, I hope you will find someone better.`);
    } else if (Question.globalAnswers.v3JoeGymWhyDislikeAnn === "IWantVanessa") {
        mc.talk(`I want someone like Joey's girlfriend.`);
        emily.talk(`Oh...`);
        emily.talk(`Does she have a sister?`);
        mc.talk(`Not that I know of.`);
        emily.talk(`Bad luck for you.`);
    } else if (Question.globalAnswers.v3JoeGymWhyDislikeAnn === "dunno") {
        mc.talk(`I don't really know why. I just don't feel anything around her.`);
        emily.talk(`In that case, it's better that you stopped it before it began.`);
        emily.talk(`You are a good person, I bet you didn't want to hurt her feelings.`);
    }

    return jump(V5EmilyBeach4, "V5EmilyBeach4");
};
export const V5EmilyBeach4 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.BeachEmily_13);
    mc.talk(`How come we are talking just about me?`);
    emily.talk(`Because I ask questions faster.`);
    mc.talk(`Tell me about you! How was it to live by yourself?`);
    emily.talk(`I can't lie, I really missed being here.`);
    emily.talk(`I felt a bit lonely at first because I moved to a new city and I didn't know anyone.`);
    mc.talk(`That wasn't your choice, you moved because your internship was too far away from home.`);
    emily.talk(`Oh, that was a lie... I get an internship close to home, but I felt like it was my time to leave.`);
    mc.talk(`Why am I just now hearing this?`);
    emily.talk(`Because I had mixed feelings about leaving, and I felt that if someone had said the right words I would have stayed.`);
    mc.talk(`Oh, I get it.`);

    mc.talk(`It must have been hard being alone in a new city without knowing anyone.`);
    emily.talk(`Actually, I met someone right off the bat. A guy.`);

    ImageClass.setImage(images.v5.BeachEmily_14_2);
    emily.talk(`He hit on me while I was on my first shopping spree. He approached me and we started talking.`);
    emily.talk(`But I won't lie, I wouldn't have spent time talking to him if I wasn't feeling a bit lonely.`);
    mc.talk(`That was perfect timing from him.`);
    emily.talk(`Yea...`);

    return jump(V5EmilyBeachLookingAtJoey, "V5EmilyBeachLookingAtJoey");
};

export const V5EmilyBeachLookingAtJoey = async (): Promise<any> => {
    ImageClass.setImage(images.v5.BeachEmily_14);
    emily.talk(`Hold on for a second. What's going on there?`);
    ImageClass.setImage(images.v5.BeachEmily_16);
    emily.talk(`...`);
    ImageClass.setImage(images.v5.BeachEmily_17);
    emily.talk(`Do you like what you see? Haha.`);
    mc.talk(`Who doesn't?`);

    emily.talk(`Is that his girlfriend?`);
    mc.talk(`No, it's not.`);
    emily.talk(`I wonder what she would think if she saw him right now.`);
    mc.talk(`You obviously don't know her.`);
    emily.talk(`Is there something wrong with her?`);
    mc.talk(`You can say that...`);
    ImageClass.setImage(images.v5.BeachEmily_16);
    emily.talk(`I know I shouldn't stare but I can't look away.`);
    emily.talk(`I'm too curious to know what's going on.`);

    ImageClass.setImage(images.v5.BeachEmily_18);
    emily.talk(`They are exchanging numbers!`);
    ImageClass.setImage(images.v5.BeachEmily_19);
    mc.talk(`I don't see him writing her number.`);
    ImageClass.setImage(images.v5.BeachEmily_20);
    emily.talk(`You are right.`);
    ImageClass.setImage(images.v5.BeachEmily_21);
    emily.talk(`I've done that so many times.\nShe is obviously not gonna call.`);
    emily.talk(`Girls do that when they are too nice to tell the guy they are not interested.`);
    mc.talk(`Well... I believe she was the one who approached him.`);

    ImageClass.setImage(images.v5.BeachEmily_22);
    emily.talk(`Mmm... So I don't know.`);
    ImageClass.setImage(images.v5.BeachEmily_23);
    emily.talk(`She left.`);
    emily.talk(`I'm so curious about what they talked about!`);
    mc.talk(`I'm sure you are... You've always been the curious type.`);
    emily.talk(`Too bad you are not talking.`);
    mc.talk(`Yeah...`);

    return jump(V5EmilyBeach5, "V5EmilyBeach5");
};

export const V5EmilyBeach5 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.BeachEmily_23);

    mc.talk(`Back to what we were talking about before...`);
    mc.talk(`You haven't told me why you broke up with your boyfriend...`);
    emily.talk(`I'd rather not talk about that... Let's say that things just didn't work out...`);
    mc.talk(`Ok, I respect that. But if you ever want to talk about it, I'm here.`);
    emily.talk(`Thanks ${mc.name}.`);
    mc.talk(`So what are your plans for the future? Since you are back and all of that...`);
    emily.talk(`For the next few days I want to do nothing! I just want some peace and quiet.`);

    mc.talk(`You? Doing nothing? I can't imagine that; you are always so active.`);
    emily.talk(`By doing nothing I mean go shopping.`);
    mc.talk(`There's the Emily I remember!`);

    emily.talk(`I thought I could stay for longer, but I'm exhausted. I should really get some sleep.`);
    mc.talk(`Sure, let's get back home.`);

    emily.talk(`It was nice, I'm glad we had some time to catch up!`);
    mc.talk(`Me too.`);

    return jump(V5AfterBeachJoeyOrEmily, "V5AfterBeachJoeyOrEmily");
};


